export default __webpack_public_path__ + "static/media/poppins-bold.48582914.woff";